// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-07: Overlay panels (TapePanel, AdvisoryPanel) styles.
 *
 * Uses CSS variables from .vnsc-root for theme inheritance.
 * No hardcoded colors — all values derive from --vnsc-* variables.
 */

/* ── Tape Panel ────────────────────────────────────────────────────── */
.vnsc-tape-panel {
	position: relative;
	height: 100%;
	flex-shrink: 0;
	width: 240px;
	z-index: 51;
	background: var(--vnsc-bg-primary);
	border-left: 1px solid var(--vnsc-border);
	display: flex;
	flex-direction: column;
	font-size: var(--vnsc-font-sm);
	color: var(--vnsc-text-primary);
	overflow: hidden;
}

.vnsc-tape-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 6px 8px 5px;
	border-bottom: 1px solid var(--vnsc-border);
	background: var(--vnsc-bg-secondary);
	flex-shrink: 0;
}

.vnsc-tape-panel__filter {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 5px 8px;
	border-bottom: 1px solid var(--vnsc-border);
	flex-shrink: 0;
}

.vnsc-tape-panel__columns {
	display: grid;
	grid-template-columns: 52px 70px 52px 44px 22px;
	padding: 2px 4px;
	color: var(--vnsc-text-muted);
	font-size: var(--vnsc-font-xs);
	border-bottom: 1px solid var(--vnsc-border);
	flex-shrink: 0;
}

.vnsc-tape-panel__list {
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
}

.vnsc-tape-panel__row {
	display: grid;
	grid-template-columns: 52px 70px 52px 44px 22px;
	height: 22px;
	align-items: center;
	padding: 0 4px;
	border-bottom: 1px solid var(--vnsc-border);
}

.vnsc-tape-panel__row--whale {
	background: var(--vnsc-bg-tertiary);
	border-bottom-color: var(--vnsc-accent);
}

.vnsc-tape-panel__footer {
	padding: 3px 8px;
	border-top: 1px solid var(--vnsc-border);
	color: var(--vnsc-text-muted);
	font-size: var(--vnsc-font-xs);
	flex-shrink: 0;
}

/* ── Advisory Panel ────────────────────────────────────────────────── */
.vnsc-advisory-panel {
	position: relative;
	height: 100%;
	flex-shrink: 0;
	width: 260px;
	z-index: 50;
	background: var(--vnsc-bg-primary);
	border-left: 1px solid var(--vnsc-border);
	display: flex;
	flex-direction: column;
	font-size: var(--vnsc-font-md);
	color: var(--vnsc-text-primary);
	overflow: hidden;
}

.vnsc-advisory-panel__header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px 8px;
	border-bottom: 1px solid var(--vnsc-border);
	background: var(--vnsc-bg-secondary);
}

.vnsc-advisory-panel__body {
	flex: 1;
	overflow-y: auto;
	padding: 12px;
}

.vnsc-advisory-panel__decision {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 12px;
}

.vnsc-advisory-panel__decision-badge {
	flex: 1;
	padding: 8px 12px;
	border-radius: var(--vnsc-radius-lg);
	background: var(--vnsc-text-secondary);
	color: var(--vnsc-bg-primary);
	font-weight: 700;
	font-size: var(--vnsc-font-lg);
	text-align: center;
	letter-spacing: 0.5px;
}

.vnsc-advisory-panel__confidence {
	text-align: center;
}

.vnsc-advisory-panel__confidence-label {
	color: var(--vnsc-text-muted);
	font-size: var(--vnsc-font-xs);
}

.vnsc-advisory-panel__confidence-value {
	font-weight: 700;
	font-size: var(--vnsc-font-md);
}

.vnsc-advisory-panel__agents {
	margin-bottom: 8px;
}

.vnsc-advisory-panel__agent-row {
	border-bottom: 1px solid var(--vnsc-border);
	padding-bottom: 8px;
	margin-bottom: 8px;
}

.vnsc-advisory-panel__agent-header {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	user-select: none;
}

.vnsc-advisory-panel__agent-name {
	flex: 1;
	font-size: var(--vnsc-font-md);
	color: var(--vnsc-text-primary);
	font-weight: 500;
}

.vnsc-advisory-panel__agent-weight {
	color: var(--vnsc-text-muted);
	font-size: var(--vnsc-font-sm);
	margin-left: 4px;
}

.vnsc-advisory-panel__agent-signal {
	font-size: var(--vnsc-font-xs);
	font-weight: 700;
	padding: 2px 6px;
	border-radius: var(--vnsc-radius-md);
	background: var(--vnsc-text-secondary);
	color: var(--vnsc-bg-primary);
	letter-spacing: 0.5px;
}

.vnsc-advisory-panel__agent-chevron {
	color: var(--vnsc-text-muted);
	font-size: var(--vnsc-font-xs);
}

.vnsc-advisory-panel__agent-bar {
	height: 4px;
	background: var(--vnsc-border);
	border-radius: 2px;
	margin-top: 6px;
	overflow: hidden;
}

.vnsc-advisory-panel__agent-bar-fill {
	height: 100%;
	border-radius: 2px;
	transition: width 0.3s ease;
}

.vnsc-advisory-panel__agent-explanation {
	margin-top: 8px;
	font-size: var(--vnsc-font-sm);
	color: var(--vnsc-text-secondary);
	line-height: 1.5;
	white-space: pre-wrap;
	word-break: break-word;
}

.vnsc-advisory-panel__skeleton {
	height: 40px;
	background: var(--vnsc-bg-tertiary);
	border-radius: var(--vnsc-radius-md);
	margin-bottom: 8px;
	animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
	0%, 100% { opacity: 1; }
	50% { opacity: 0.5; }
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/overlays.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,yEAAyE;AACzE;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,WAAW;CACX,kCAAkC;CAClC,yCAAyC;CACzC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB,2CAA2C;CAC3C,oCAAoC;CACpC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,gBAAgB;CAChB,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,aAAa;CACb,+CAA+C;CAC/C,gBAAgB;CAChB,6BAA6B;CAC7B,8BAA8B;CAC9B,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,+CAA+C;CAC/C,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,2CAA2C;AAC5C;;AAEA;CACC,mCAAmC;CACnC,uCAAuC;AACxC;;AAEA;CACC,gBAAgB;CAChB,wCAAwC;CACxC,6BAA6B;CAC7B,8BAA8B;CAC9B,cAAc;AACf;;AAEA,yEAAyE;AACzE;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,WAAW;CACX,kCAAkC;CAClC,yCAAyC;CACzC,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,sBAAsB;CACtB,2CAA2C;CAC3C,oCAAoC;AACrC;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,OAAO;CACP,iBAAiB;CACjB,oCAAoC;CACpC,sCAAsC;CACtC,6BAA6B;CAC7B,gBAAgB;CAChB,8BAA8B;CAC9B,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,OAAO;CACP,8BAA8B;CAC9B,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,gBAAgB;CAChB,oCAAoC;CACpC,sCAAsC;CACtC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,8BAA8B;CAC9B,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,8BAA8B;CAC9B,iCAAiC;CACjC,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,mCAAmC;CACnC,oCAAoC;CACpC,kBAAkB;CAClB,0CAA0C;AAC3C;;AAEA;CACC,WAAW,UAAU,EAAE;CACvB,MAAM,YAAY,EAAE;AACrB","sourcesContent":["/**\r\n * WE2 P4-07: Overlay panels (TapePanel, AdvisoryPanel) styles.\r\n *\r\n * Uses CSS variables from .vnsc-root for theme inheritance.\r\n * No hardcoded colors — all values derive from --vnsc-* variables.\r\n */\r\n\r\n/* ── Tape Panel ────────────────────────────────────────────────────── */\r\n.vnsc-tape-panel {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\tflex-shrink: 0;\r\n\twidth: 240px;\r\n\tz-index: 51;\r\n\tbackground: var(--vnsc-bg-primary);\r\n\tborder-left: 1px solid var(--vnsc-border);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tcolor: var(--vnsc-text-primary);\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-tape-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 6px 8px 5px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tbackground: var(--vnsc-bg-secondary);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-tape-panel__filter {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 6px;\r\n\tpadding: 5px 8px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-tape-panel__columns {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 52px 70px 52px 44px 22px;\r\n\tpadding: 2px 4px;\r\n\tcolor: var(--vnsc-text-muted);\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.vnsc-tape-panel__list {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n}\r\n\r\n.vnsc-tape-panel__row {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: 52px 70px 52px 44px 22px;\r\n\theight: 22px;\r\n\talign-items: center;\r\n\tpadding: 0 4px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.vnsc-tape-panel__row--whale {\r\n\tbackground: var(--vnsc-bg-tertiary);\r\n\tborder-bottom-color: var(--vnsc-accent);\r\n}\r\n\r\n.vnsc-tape-panel__footer {\r\n\tpadding: 3px 8px;\r\n\tborder-top: 1px solid var(--vnsc-border);\r\n\tcolor: var(--vnsc-text-muted);\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tflex-shrink: 0;\r\n}\r\n\r\n/* ── Advisory Panel ────────────────────────────────────────────────── */\r\n.vnsc-advisory-panel {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\tflex-shrink: 0;\r\n\twidth: 260px;\r\n\tz-index: 50;\r\n\tbackground: var(--vnsc-bg-primary);\r\n\tborder-left: 1px solid var(--vnsc-border);\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tfont-size: var(--vnsc-font-md);\r\n\tcolor: var(--vnsc-text-primary);\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-advisory-panel__header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 10px 12px 8px;\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tbackground: var(--vnsc-bg-secondary);\r\n}\r\n\r\n.vnsc-advisory-panel__body {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 12px;\r\n}\r\n\r\n.vnsc-advisory-panel__decision {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n\tmargin-bottom: 12px;\r\n}\r\n\r\n.vnsc-advisory-panel__decision-badge {\r\n\tflex: 1;\r\n\tpadding: 8px 12px;\r\n\tborder-radius: var(--vnsc-radius-lg);\r\n\tbackground: var(--vnsc-text-secondary);\r\n\tcolor: var(--vnsc-bg-primary);\r\n\tfont-weight: 700;\r\n\tfont-size: var(--vnsc-font-lg);\r\n\ttext-align: center;\r\n\tletter-spacing: 0.5px;\r\n}\r\n\r\n.vnsc-advisory-panel__confidence {\r\n\ttext-align: center;\r\n}\r\n\r\n.vnsc-advisory-panel__confidence-label {\r\n\tcolor: var(--vnsc-text-muted);\r\n\tfont-size: var(--vnsc-font-xs);\r\n}\r\n\r\n.vnsc-advisory-panel__confidence-value {\r\n\tfont-weight: 700;\r\n\tfont-size: var(--vnsc-font-md);\r\n}\r\n\r\n.vnsc-advisory-panel__agents {\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-row {\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tpadding-bottom: 8px;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\tuser-select: none;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-name {\r\n\tflex: 1;\r\n\tfont-size: var(--vnsc-font-md);\r\n\tcolor: var(--vnsc-text-primary);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-weight {\r\n\tcolor: var(--vnsc-text-muted);\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tmargin-left: 4px;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-signal {\r\n\tfont-size: var(--vnsc-font-xs);\r\n\tfont-weight: 700;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tbackground: var(--vnsc-text-secondary);\r\n\tcolor: var(--vnsc-bg-primary);\r\n\tletter-spacing: 0.5px;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-chevron {\r\n\tcolor: var(--vnsc-text-muted);\r\n\tfont-size: var(--vnsc-font-xs);\r\n}\r\n\r\n.vnsc-advisory-panel__agent-bar {\r\n\theight: 4px;\r\n\tbackground: var(--vnsc-border);\r\n\tborder-radius: 2px;\r\n\tmargin-top: 6px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-bar-fill {\r\n\theight: 100%;\r\n\tborder-radius: 2px;\r\n\ttransition: width 0.3s ease;\r\n}\r\n\r\n.vnsc-advisory-panel__agent-explanation {\r\n\tmargin-top: 8px;\r\n\tfont-size: var(--vnsc-font-sm);\r\n\tcolor: var(--vnsc-text-secondary);\r\n\tline-height: 1.5;\r\n\twhite-space: pre-wrap;\r\n\tword-break: break-word;\r\n}\r\n\r\n.vnsc-advisory-panel__skeleton {\r\n\theight: 40px;\r\n\tbackground: var(--vnsc-bg-tertiary);\r\n\tborder-radius: var(--vnsc-radius-md);\r\n\tmargin-bottom: 8px;\r\n\tanimation: pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n\t0%, 100% { opacity: 1; }\r\n\t50% { opacity: 0.5; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
